import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const StatusBadge = ({ status, className = '' }) => {
  const { t } = useLanguage();

  const statusConfig = {
    TOP_DISTINGUISHED: {
      color: 'bg-green-100 text-green-800 border-green-200',
      label: t('topDistinguished')
    },
    PASSED: {
      color: 'bg-blue-100 text-blue-800 border-blue-200',
      label: t('passed')
    },
    FAIL: {
      color: 'bg-orange-100 text-orange-800 border-orange-200',
      label: t('didNotPass')
    },
    ASSIGNMENT_COMPLETE: {
      color: 'bg-green-100 text-green-800 border-green-200',
      label: t('assignmentComplete')
    }
  };

  const config = statusConfig[status] || statusConfig.FAIL;

  return (
    <span
      className={`
        inline-flex items-center px-3 py-1 rounded-full text-sm font-medium border
        ${config.color}
        ${className}
      `}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;